var _excluded = ["label", "description", "error", "autocomplete", "className", "format", "value"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import Label from './Label';
export default React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    description = _ref.description,
    error = _ref.error,
    _ref$autocomplete = _ref.autocomplete,
    autocomplete = _ref$autocomplete === void 0 ? 'on' : _ref$autocomplete,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    format = _ref.format,
    value = _ref.value,
    input = _objectWithoutProperties(_ref, _excluded);
  var errId = error ? "errMessage-".concat(input.name) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "form-group ".concat(className, " ").concat(error ? 'has-error' : '')
  }, /*#__PURE__*/React.createElement(Label, {
    label: label,
    id: input.id,
    required: input.required
  }), description ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", null, description)) : null, /*#__PURE__*/React.createElement("div", {
    className: "cb-input-state"
  }, /*#__PURE__*/React.createElement("input", _extends({}, input, {
    value: format ? format(value) : value,
    type: input.type || 'text',
    className: "form-control",
    autoComplete: autocomplete,
    ref: ref,
    "aria-describedby": errId
  })), error ? /*#__PURE__*/React.createElement("i", {
    className: "cb-glyph cb-x-mark",
    "aria-hidden": true
  }) : null), error ? /*#__PURE__*/React.createElement("p", {
    tabIndex: "-1",
    id: errId,
    className: "cb-error-msg",
    role: "alert"
  }, error) : null);
});